import {appTaskContext} from './assistAppContext.js';

// Both voice windows use App's submission path. This envelope is context, not
// permission: the backend binds user/device/authorization independently.
export function prepareTaskTurn(text,{inputMode='text',context=appTaskContext,turnId,history=[]}={}) {
 const userText=String(text||'').trim();
 const mode=inputMode==='voice'?'voice':'text';
 return {version:1,turnId:turnId||globalThis.crypto?.randomUUID?.()||`turn_${Date.now()}`,
  inputMode:mode,userText,request:context.resolve(userText,{voice:mode==='voice',history}),app:context.current()||''};
}
